package info.rezident.app.ui.theme

import androidx.compose.runtime.Immutable
import androidx.compose.runtime.staticCompositionLocalOf
import org.jetbrains.compose.web.css.CSSNumericValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.px

val LocalAppShapes = staticCompositionLocalOf {
    appShapes
}

val appShapes = AppShapes(
    mediumRound = 16.px,
    bigRound = 24.px
)

@Immutable
data class AppShapes(
    val mediumRound: CSSNumericValue<CSSUnit.px>,
    val bigRound: CSSNumericValue<CSSUnit.px>
)